import { IntegrationsEntity } from '@citrite/sf-api';
import { getLogger } from '../logger';

export const acquireAccessToken = async (rsClientId: string) => {
	const encodedJwt = await IntegrationsEntity.jwt(rsClientId).execute();
	getLogger().logInfo('Acquired access token');
	return encodedJwt.Token;

	// Bearer token from swagger
	// return ''
};
